/* src/app/webhook-creator/webhook-creator/webhook-form-components/webhook-form-simpletable/webhook-form-simpletable.component.scss */
td {
  text-overflow: ellipsis;
  overflow: hidden;
  word-spacing: unset;
  width: 100%;
  white-space: nowrap;
}
.edit-panel-action {
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: nowrap;
  align-items: flex-start;
  padding: 12px 16px;
  color: var(--tem-ink);
  background-color: var(--tem-surface-2);
  border: 1px solid var(--tem-border);
  border-bottom: 0;
  border-radius: 2px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.row-insert-table {
  background-color: var(--tem-accent-soft);
}
/*# sourceMappingURL=webhook-form-simpletable.component.css.map */
